export default "__VITE_ASSET__8O6Qmwrd__"